import React from 'react';

import { Content } from './Content.js';
import ParagraphWithAnchor from './ParagraphWithAnchor.jsx';
import ParagraphWithoutAnchor from './ParagraphWithoutAnchor.jsx';

export default class TwoParagraphContents extends React.Component {

  render() {
    var bodyTwo = this.getBodyTwo(this.props.page);

    return (
      <div className="inner">
        <div className="centered">
          <p className="question">{Content[this.props.page].body1}</p>
          {bodyTwo}
        </div>
      </div>
    );
  }

  hasAnchorAndSignOff(page) {
    switch (page) {
      case 'contact':
      case 'services':
        return true;
      default:
        return false;
    }
  }

  getBodyTwo(page) {
    if (this.hasAnchorAndSignOff(page)) {
      return (
        <ParagraphWithAnchor page={this.props.page}/>
      );
    }

    return (
      <ParagraphWithoutAnchor page={this.props.page}/>
    );
  }

};
